import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "tinyOffset10": "registration-form-ca2d4608-tinyOffset10-WXUgJq",
  "wide9": "registration-form-ca2d4608-wide9-WXUgJq",
  "confinedOffset6": "registration-form-ca2d4608-confinedOffset6-WXUgJq",
  "xwideOffset8": "registration-form-ca2d4608-xwideOffset8-WXUgJq",
  "wideOffset5": "registration-form-ca2d4608-wideOffset5-WXUgJq",
  "wide10": "registration-form-ca2d4608-wide10-WXUgJq",
  "xwide10": "registration-form-ca2d4608-xwide10-WXUgJq",
  "defaultOffset6": "registration-form-ca2d4608-defaultOffset6-WXUgJq",
  "defaultOffset5": "registration-form-ca2d4608-defaultOffset5-WXUgJq",
  "xwide2": "registration-form-ca2d4608-xwide2-WXUgJq",
  "tinyOffset0": "registration-form-ca2d4608-tinyOffset0-WXUgJq",
  "default3": "registration-form-ca2d4608-default3-WXUgJq",
  "wideGridContainer": "registration-form-ca2d4608-wideGridContainer-WXUgJq",
  "confinedOffset2": "registration-form-ca2d4608-confinedOffset2-WXUgJq",
  "wideOffset10": "registration-form-ca2d4608-wideOffset10-WXUgJq",
  "grid": "registration-form-ca2d4608-grid-WXUgJq",
  "defaultOffset3": "registration-form-ca2d4608-defaultOffset3-WXUgJq",
  "wide3": "registration-form-ca2d4608-wide3-WXUgJq",
  "xwideOffset4": "registration-form-ca2d4608-xwideOffset4-WXUgJq",
  "wideOffset6": "registration-form-ca2d4608-wideOffset6-WXUgJq",
  "defaultOffset1": "registration-form-ca2d4608-defaultOffset1-WXUgJq",
  "tiny2": "registration-form-ca2d4608-tiny2-WXUgJq",
  "default2": "registration-form-ca2d4608-default2-WXUgJq",
  "wideOffset7": "registration-form-ca2d4608-wideOffset7-WXUgJq",
  "xwideOffset10": "registration-form-ca2d4608-xwideOffset10-WXUgJq",
  "confinedOffset3": "registration-form-ca2d4608-confinedOffset3-WXUgJq",
  "defaultOffset2": "registration-form-ca2d4608-defaultOffset2-WXUgJq",
  "tinyOffset6": "registration-form-ca2d4608-tinyOffset6-WXUgJq",
  "confined0": "registration-form-ca2d4608-confined0-WXUgJq",
  "confinedOffset1": "registration-form-ca2d4608-confinedOffset1-WXUgJq",
  "wideOffset4": "registration-form-ca2d4608-wideOffset4-WXUgJq",
  "tiny10": "registration-form-ca2d4608-tiny10-WXUgJq",
  "xwide7": "registration-form-ca2d4608-xwide7-WXUgJq",
  "confined8": "registration-form-ca2d4608-confined8-WXUgJq",
  "wide4": "registration-form-ca2d4608-wide4-WXUgJq",
  "confinedOffset0": "registration-form-ca2d4608-confinedOffset0-WXUgJq",
  "col": "registration-form-ca2d4608-col-WXUgJq",
  "tiny9": "registration-form-ca2d4608-tiny9-WXUgJq",
  "tinyOffset9": "registration-form-ca2d4608-tinyOffset9-WXUgJq",
  "tiny12": "registration-form-ca2d4608-tiny12-WXUgJq",
  "xwideOffset5": "registration-form-ca2d4608-xwideOffset5-WXUgJq",
  "confined11": "registration-form-ca2d4608-confined11-WXUgJq",
  "confined5": "registration-form-ca2d4608-confined5-WXUgJq",
  "defaultOffset7": "registration-form-ca2d4608-defaultOffset7-WXUgJq",
  "xwide5": "registration-form-ca2d4608-xwide5-WXUgJq",
  "gridContainer": "registration-form-ca2d4608-gridContainer-WXUgJq",
  "xwide8": "registration-form-ca2d4608-xwide8-WXUgJq",
  "default7": "registration-form-ca2d4608-default7-WXUgJq",
  "default8": "registration-form-ca2d4608-default8-WXUgJq",
  "xwideOffset7": "registration-form-ca2d4608-xwideOffset7-WXUgJq",
  "wide8": "registration-form-ca2d4608-wide8-WXUgJq",
  "confined4": "registration-form-ca2d4608-confined4-WXUgJq",
  "wide0": "registration-form-ca2d4608-wide0-WXUgJq",
  "confinedOffset10": "registration-form-ca2d4608-confinedOffset10-WXUgJq",
  "armstrongGridContainer": "registration-form-ca2d4608-armstrongGridContainer-WXUgJq",
  "default6": "registration-form-ca2d4608-default6-WXUgJq",
  "default9": "registration-form-ca2d4608-default9-WXUgJq",
  "tiny4": "registration-form-ca2d4608-tiny4-WXUgJq",
  "confined10": "registration-form-ca2d4608-confined10-WXUgJq",
  "wide12": "registration-form-ca2d4608-wide12-WXUgJq",
  "default12": "registration-form-ca2d4608-default12-WXUgJq",
  "xwideOffset6": "registration-form-ca2d4608-xwideOffset6-WXUgJq",
  "defaultOffset8": "registration-form-ca2d4608-defaultOffset8-WXUgJq",
  "standardGridContainer": "registration-form-ca2d4608-standardGridContainer-WXUgJq",
  "wideOffset2": "registration-form-ca2d4608-wideOffset2-WXUgJq",
  "tinyOffset2": "registration-form-ca2d4608-tinyOffset2-WXUgJq",
  "default1": "registration-form-ca2d4608-default1-WXUgJq",
  "tiny1": "registration-form-ca2d4608-tiny1-WXUgJq",
  "confinedOffset9": "registration-form-ca2d4608-confinedOffset9-WXUgJq",
  "tiny8": "registration-form-ca2d4608-tiny8-WXUgJq",
  "tiny7": "registration-form-ca2d4608-tiny7-WXUgJq",
  "defaultOffset10": "registration-form-ca2d4608-defaultOffset10-WXUgJq",
  "confined3": "registration-form-ca2d4608-confined3-WXUgJq",
  "confined7": "registration-form-ca2d4608-confined7-WXUgJq",
  "wide2": "registration-form-ca2d4608-wide2-WXUgJq",
  "wide11": "registration-form-ca2d4608-wide11-WXUgJq",
  "xwide4": "registration-form-ca2d4608-xwide4-WXUgJq",
  "default10": "registration-form-ca2d4608-default10-WXUgJq",
  "tinyOffset5": "registration-form-ca2d4608-tinyOffset5-WXUgJq",
  "tinyOffset11": "registration-form-ca2d4608-tinyOffset11-WXUgJq",
  "tinyOffset7": "registration-form-ca2d4608-tinyOffset7-WXUgJq",
  "tinyOffset3": "registration-form-ca2d4608-tinyOffset3-WXUgJq",
  "confined2": "registration-form-ca2d4608-confined2-WXUgJq",
  "confined6": "registration-form-ca2d4608-confined6-WXUgJq",
  "confinedOffset7": "registration-form-ca2d4608-confinedOffset7-WXUgJq",
  "wide5": "registration-form-ca2d4608-wide5-WXUgJq",
  "wideOffset11": "registration-form-ca2d4608-wideOffset11-WXUgJq",
  "xwide3": "registration-form-ca2d4608-xwide3-WXUgJq",
  "wideOffset0": "registration-form-ca2d4608-wideOffset0-WXUgJq",
  "xwideOffset0": "registration-form-ca2d4608-xwideOffset0-WXUgJq",
  "wide7": "registration-form-ca2d4608-wide7-WXUgJq",
  "xwideOffset1": "registration-form-ca2d4608-xwideOffset1-WXUgJq",
  "xwide9": "registration-form-ca2d4608-xwide9-WXUgJq",
  "xwideOffset2": "registration-form-ca2d4608-xwideOffset2-WXUgJq",
  "wideOffset9": "registration-form-ca2d4608-wideOffset9-WXUgJq",
  "wideOffset1": "registration-form-ca2d4608-wideOffset1-WXUgJq",
  "defaultOffset9": "registration-form-ca2d4608-defaultOffset9-WXUgJq",
  "xwide1": "registration-form-ca2d4608-xwide1-WXUgJq",
  "default0": "registration-form-ca2d4608-default0-WXUgJq",
  "xwide6": "registration-form-ca2d4608-xwide6-WXUgJq",
  "xwide11": "registration-form-ca2d4608-xwide11-WXUgJq",
  "tiny5": "registration-form-ca2d4608-tiny5-WXUgJq",
  "tinyOffset4": "registration-form-ca2d4608-tinyOffset4-WXUgJq",
  "confined9": "registration-form-ca2d4608-confined9-WXUgJq",
  "wideOffset8": "registration-form-ca2d4608-wideOffset8-WXUgJq",
  "default5": "registration-form-ca2d4608-default5-WXUgJq",
  "row": "registration-form-ca2d4608-row-WXUgJq",
  "confined12": "registration-form-ca2d4608-confined12-WXUgJq",
  "defaultOffset11": "registration-form-ca2d4608-defaultOffset11-WXUgJq",
  "xwideOffset9": "registration-form-ca2d4608-xwideOffset9-WXUgJq",
  "xwide12": "registration-form-ca2d4608-xwide12-WXUgJq",
  "default11": "registration-form-ca2d4608-default11-WXUgJq",
  "confinedOffset11": "registration-form-ca2d4608-confinedOffset11-WXUgJq",
  "xwideOffset11": "registration-form-ca2d4608-xwideOffset11-WXUgJq",
  "default4": "registration-form-ca2d4608-default4-WXUgJq",
  "tinyOffset8": "registration-form-ca2d4608-tinyOffset8-WXUgJq",
  "wideOffset3": "registration-form-ca2d4608-wideOffset3-WXUgJq",
  "tiny0": "registration-form-ca2d4608-tiny0-WXUgJq",
  "tiny6": "registration-form-ca2d4608-tiny6-WXUgJq",
  "wide1": "registration-form-ca2d4608-wide1-WXUgJq",
  "confinedOffset4": "registration-form-ca2d4608-confinedOffset4-WXUgJq",
  "confined1": "registration-form-ca2d4608-confined1-WXUgJq",
  "defaultOffset4": "registration-form-ca2d4608-defaultOffset4-WXUgJq",
  "wide6": "registration-form-ca2d4608-wide6-WXUgJq",
  "tiny3": "registration-form-ca2d4608-tiny3-WXUgJq",
  "xwide0": "registration-form-ca2d4608-xwide0-WXUgJq",
  "confinedOffset5": "registration-form-ca2d4608-confinedOffset5-WXUgJq",
  "confinedOffset8": "registration-form-ca2d4608-confinedOffset8-WXUgJq",
  "tinyOffset1": "registration-form-ca2d4608-tinyOffset1-WXUgJq",
  "tiny11": "registration-form-ca2d4608-tiny11-WXUgJq",
  "xwideOffset3": "registration-form-ca2d4608-xwideOffset3-WXUgJq"
};